import { faExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgress } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { EditorState } from "../types";
import Console from "./Console";
import Help from "./Help";
import { OutputBody, OutputBox, OutputHeader, OutputButton, OutputColor, OutputHeaderText } from "./OutputBox";
import ScrollBox from "./ScrollBox";
var EditorOutput = function EditorOutput(_a) {
  var editorState = _a.editorState,
    getPasteLink = _a.getPasteLink,
    onClose = _a.onClose,
    outputContent = _a.outputContent,
    outputHeight = _a.outputHeight,
    pasteDisabled = _a.pasteDisabled,
    sendInput = _a.sendInput;
  var t = useTranslation()[0];
  var scrollBoxRef = React.createRef();
  var initializing = editorState === EditorState.WorkerInitializing;
  var running = (editorState & EditorState.WorkerActive) !== 0;
  var waitingInput = editorState === EditorState.WaitingInput;
  var getStatus = function getStatus() {
    if (waitingInput) {
      return React.createElement(React.Fragment, null, React.createElement(FontAwesomeIcon, {
        icon: faExclamation
      }), React.createElement(OutputHeaderText, null, t("waitingForInput")));
    } else if (running) {
      return React.createElement(React.Fragment, null, React.createElement(CircularProgress, {
        size: 25,
        color: "inherit",
        disableShrink: true
      }), React.createElement(OutputHeaderText, null, initializing ? t("initializing") : t("running")));
    }
    return null;
  };
  return React.createElement(OutputBox, null, React.createElement(OutputHeader, {
    title: t("outputTitle"),
    color: waitingInput ? OutputColor.Orange : OutputColor.Gray
  }, getStatus(), React.createElement(Help, {
    getPasteUrl: getPasteLink,
    pasteDisabled: running || pasteDisabled
  }), React.createElement(OutputButton, {
    label: t("button.close"),
    onClick: onClose,
    dataCy: "close-btn"
  })), React.createElement(OutputBody, null, React.createElement(ScrollBox, {
    maxHeight: outputHeight,
    ref: scrollBoxRef
  }, React.createElement(Console, {
    inputRequested: waitingInput,
    outputContent: outputContent,
    scrollToBottom: function scrollToBottom() {
      var _a;
      return (_a = scrollBoxRef.current) === null || _a === void 0 ? void 0 : _a.scrollToBottom();
    },
    sendInput: sendInput
  }))));
};
export default EditorOutput;